// services/cpq.js
import apiClient from './api';

/**
 * Fetches related CPQ data for a list of products.
 * Corresponds to: GET /api/products/cpq/:orgId/related-data
 */
export async function getCPQProductData(orgId, products, use_existing) {
  const response = await apiClient.post(`/products/cpq/${orgId}/related-data`, {
    products,
    use_existing,
  });
  return response.data;
}
/**
 * Fetches CPQ Product Rules.
 * Corresponds to: GET /api/products/cpq/:orgId/rules
 */
export async function getCPQProductRules(orgId, products) {
  const response = await apiClient.post(`/products/cpq/${orgId}/rules`, { products });
  return response.data;
}

/**
 * Fetches CPQ Pricebooks.
 * Corresponds to: GET /api/products/cpq/:orgId/pricebooks
 */
export async function getCPQPricebooks(orgId, products) {
  const response = await apiClient.post(`/products/cpq/${orgId}/pricebooks`, { products });
  return response.data;
}

/**
 * Fetches CPQ Product Price Models.
 * Corresponds to: GET /api/products/cpq/:orgId/price-models
 */
export async function getCPQPriceModel(orgId, products) {
  const response = await apiClient.post(`/products/cpq/${orgId}/price-models`, { products });
  return response.data;
}

/**
 * Fetches CPQ Consumption Schedules.
 * Corresponds to: GET /api/products/cpq/:orgId/consumption-schedules
 */
export async function getCPQConsumptionSchedule(orgId, products) {
  const response = await apiClient.post(`/products/cpq/${orgId}/consumption-schedules`, { products });
  return response.data;
}

/**
 * Fetches CPQ Discount Schedules.
 * Corresponds to: GET /api/products/cpq/:orgId/discount-schedules
 */
export async function getCPQDiscountSchedule(orgId, products) {
  const response = await apiClient.post(`/products/cpq/${orgId}/discount-schedules`, { products });
  return response.data;
}

/**
 * Fetches CPQ Price Rules for a specific org.
 * Corresponds to: GET /api/products/cpq/:orgId/price-rules
 */
export async function getCPQPriceRules(orgId) {
  const response = await apiClient.get(`/products/cpq/${orgId}/price-rules`);
  return response.data;
}

/**
 * Fetches CPQ Quote Templates for a specific org.
 * Corresponds to: GET /api/products/cpq/:orgId/quote-templates
 */
export async function getCPQQuoteTemplates(orgId) {
  const response = await apiClient.get(`/products/cpq/${orgId}/quote-templates`);
  return response.data;
}
